import QRCodeStyling from 'qr-code-styling';
// see: https://github.com/kozakdenys/qr-code-styling
export default function() {
   const el = document.getElementById('qrcode');
   if (el) {
      const qrCode = new QRCodeStyling({
         width: el.dataset.canvasWidth,
         height: el.dataset.canvasHeight,
         type: 'canvas',
         data: el.dataset.pageUrl,
         image: null,
         qrOptions:{
            typeNumber: '0',
            mode: 'Byte',
            errorCorrectionLevel: 'Q'
         },
         dotsOptions: {
            color: '#000000',
            type: 'square'
         },
         cornersSquareOptions: {
            type: 'square',
            color: '#000000'
         },
         cornersDotOptions: {
            type: 'square',
            color: '#000000',
            gradient: null
         },
   });
   qrCode.append(el);
   }
}
